import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "MiniBasket",
    component: () => (__SERVER__ ? require("./mini-basket-view") : import("./mini-basket-view"))
});

export default definition;
